module.exports = __webpack_public_path__ + "img/oil-barrel.59c3681e.png";